import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { StyledInput } from "../ui/StyledInput";
import { api } from "../../config/api";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { CurrencyRupee } from "@mui/icons-material";
import { StyledButton } from "../ui/StyledButton";
import { onlyNumber } from "../../utils/inputHelper";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  p: 4,
  minHeight: "200px",
  borderRadius: "6px",
};

interface RazorpayResponse {
  error: {
    code: string;
    description: string;
    source: string;
    step: string;
    reason: string;
    metadata: {
      order_id: string;
      payment_id: string;
    };
  };
}

const AddWalletModal = ({
  open,
  handleClose,
}: {
  open: boolean;
  handleClose: () => void;
}) => {
  const [amount, setAmount] = useState("100");

  const [canSubmit, setCanSubmit] = useState(true);

  useEffect(() => {
    if (!parseInt(amount)) {
      setAmount("0");
    }
    if (parseInt(amount) % 100 !== 0 || parseInt(amount) === 0) {
      setCanSubmit(false);
    } else {
      setCanSubmit(true);
    }
  }, [amount]);

  const fromButtonAddAmount = (value: number) => {
    setAmount(`${parseInt(amount) + value}`);
  };

  const handleAmountChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const amount = onlyNumber(event, 100);
    setAmount(amount);
  };

  const paymentHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    const currency = "INR";

    api
      .post("/payment/razorpayOrderAPIView/", {
        amount: amount,
        currency,
      })
      .then((data) => {
        const order = data.data.data;
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          amount: order.amount,
          currency,
          name: "Hipship",
          description: "Test Transaction",
          order_id: order.id,
          handler: async (response: any) => {
            const apiBody = {
              payment_id: response.razorpay_payment_id,
              order_id: response.razorpay_order_id,
              signature: response.razorpay_signature,
              amount: order.amount / 100,
            };

            api
              .post("/payment/razorpayPaymentStatus/", apiBody)
              .then((data) => {
                toast.success("Wallet recharged successfully");
                handleClose();
              })
              .catch((error) => {
                toast.error("Please Try Again");
              });
          },

          prefill: {
            name: "Web Dev Matrix",
            email: "webdevmatrix@example.com",
            contact: "9000000000",
          },
        };

        var rzp1 = new window.Razorpay(options);
        rzp1.on("payment.failed", function (response: RazorpayResponse) {
          toast.error("Please try again");
        });
        rzp1.open();
        e.preventDefault();
      })
      .catch((error) => console.log(error));
  };

  const formHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    paymentHandler(event);
  };

  return (
    <Modal
      open={open}
      sx={{
        backgroundColor: "#ffffffc",
      }}
      onClose={handleClose}
    >
      <Box sx={style}>
        <form onSubmit={formHandler}>
          <Stack
            justifyContent={"space-between"}
            direction={"column"}
            rowGap={"10px"}
          >
            <div>
              <Typography
                fontWeight={"600"}
                fontSize={"20px"}
                variant="h6"
                component="h2"
              >
                Recharge Your Wallet
              </Typography>
              <Typography fontSize={"14px"} marginBottom={"20px"}>
                Current Wallet Amount
                <span
                  style={{
                    color: "#008e27",
                  }}
                >
                  {" "}
                  ₹450
                </span>
              </Typography>
            </div>

            <div
              style={{
                backgroundColor: "#77b2dc16",
                padding: "20px",
                borderRadius: "10px",
                textAlign: "left",
              }}
            >
              <Typography fontSize={"16px"}>
                Enter Amount in Multiples of 100 Below
              </Typography>
              <Stack
                direction={"row"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <div
                  style={{
                    position: "relative",

                    width: "100%",
                  }}
                >
                  <CurrencyRupee
                    sx={{
                      position: "absolute",
                      zIndex: "50",
                      top: "32%",
                      left: "6px",
                    }}
                  />
                  <StyledInput
                    sx={{
                      "div input": {
                        paddingLeft: "30px !important",
                      },
                    }}
                    value={amount}
                    placeholder="Enter Amount"
                    onChange={handleAmountChange}
                    fullWidth
                  />
                </div>
              </Stack>
              {!canSubmit && (
                <Typography marginTop={"6px"} fontSize={"11px"} color={"red"}>
                  Please enter in multiples of 100
                </Typography>
              )}
              <Typography fontSize={"12px"} marginTop={"10px"}>
                Min value:₹100 & Max value: ₹50,00,000
              </Typography>
              <Stack>
                <Typography fontSize={"14px"} marginTop={"20px"}>
                  Or Select From Below
                </Typography>
                <Stack
                  direction={"row"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  marginTop={"4px"}
                  gap={"10px"}
                >
                  <Button
                    onClick={() => fromButtonAddAmount(100)}
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                    }}
                  >
                    +100
                  </Button>
                  <Button
                    onClick={() => fromButtonAddAmount(500)}
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                    }}
                  >
                    +500
                  </Button>
                  <Button
                    onClick={() => fromButtonAddAmount(1000)}
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                    }}
                  >
                    +1000
                  </Button>
                  <Button
                    onClick={() => fromButtonAddAmount(5000)}
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                    }}
                  >
                    +5000
                  </Button>
                </Stack>
              </Stack>
            </div>

            <Stack
              flexDirection={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              marginTop={"20px"}
            >
              <StyledButton
                disabled={!canSubmit}
                type="submit"
                variant="contained"
              >
                Continue to Payment
              </StyledButton>
            </Stack>
          </Stack>
        </form>
      </Box>
    </Modal>
  );
};

export default AddWalletModal;
